import { memo, useMemo } from 'react'
//import { useRouteMatch } from 'react-router-dom'
import { BroadcastTypeEnum, ChatTypeEnum } from '@medentee/enums'
//import { useTranslation } from 'react-i18next'

import { useQuery } from 'services/query'
import { getEvents, TGetEventsPayload } from 'api/events'
import {
  createLoadingSelector,
  useAppSelector,
  GET_CHAT_ROOMS,
  isBusinessAccountSelector,
  GET_BROADCASTS,
  selectChatIdsByType
} from 'store'
import {
  TUnityHubRoomsNavLayoutItem,
  UnityHubRoomsNavLayout
  // UnityHubChannelIcon,
  // TUnityHubRoomsNavLayoutControl
} from 'App/components/UnityHub'
import { UnityHubRoomsBroadcastList } from 'App/components/UnityHub/UnityHubRoomsBroadcastList'

import { UnityHubRoomsNavEventsList } from '../../UnityHub/UnityHubRoomsNavEventsList'

import { CommunityRoomsNavTextList } from './CommunityRoomsNavTextList'
import { CommunityRoomsNavHighlights } from './CommunityRoomsNavHighlights'

const loadingChatRoomsSelector = createLoadingSelector([GET_CHAT_ROOMS])
const loadingBroadcastsSelector = createLoadingSelector([GET_BROADCASTS])

type TCommunityRoomsNavProps = {
  communityId: string
}

const CommunityRoomsNavView = ({ communityId }: TCommunityRoomsNavProps) => {
  //const { t } = useTranslation()

  const { data } = useQuery({
    queryKey: ['available-events', communityId],
    queryFn: () => getEvents({ communityId } as TGetEventsPayload)
  })

  const loadingChatRooms = useAppSelector(
    (state) => loadingChatRoomsSelector(state) && !state.chat.chatRooms.ids.length
  )
  const loadingBroadcasts = useAppSelector(loadingBroadcastsSelector)
  const isBusinessAccount = useAppSelector(isBusinessAccountSelector)
  const broadcastsIdsLength = useAppSelector((state) => !!state.broadcasts.data.ids.length)
  const newsIds = useAppSelector(selectChatIdsByType(ChatTypeEnum.COMMUNITY_NEWS))
  const textChatIds = useAppSelector(selectChatIdsByType(ChatTypeEnum.COMMUNITY_CHANNEL))

  //const { url } = useRouteMatch()

  const items = useMemo<TUnityHubRoomsNavLayoutItem[]>(
    () => [
      {
        key: 'highlights',
        item: <CommunityRoomsNavHighlights />
      },
      {
        key: 'broadcast',
        item: (
          <UnityHubRoomsBroadcastList entityId={communityId} type={BroadcastTypeEnum.COMMUNITY} />
        ),
        loading: loadingBroadcasts,
        hidden: !isBusinessAccount && !broadcastsIdsLength
      },

      {
        key: 'events',
        item: <UnityHubRoomsNavEventsList communityId={communityId} />,
        hidden: !isBusinessAccount && !data?.results.length
      },
      {
        key: 'news-channel',
        item: <CommunityRoomsNavTextList variant="news" communityId={communityId} />,
        loading: loadingChatRooms,
        hidden: !isBusinessAccount && !newsIds.length
      },
      {
        key: 'text-channel',
        item: <CommunityRoomsNavTextList variant="chat" communityId={communityId} />,
        loading: loadingChatRooms,
        hidden: !isBusinessAccount && !textChatIds.length
      }
    ],
    [
      communityId,
      loadingBroadcasts,
      broadcastsIdsLength,
      isBusinessAccount,
      loadingChatRooms,
      newsIds.length,
      textChatIds.length
    ]
  )

  // const controls = useMemo<TUnityHubRoomsNavLayoutControl[]>(
  //   () => [
  //     {
  //       key: 'members',
  //       to: `${url}/members`,
  //       icon: <UnityHubChannelIcon variant="members" />,
  //       name: t('communities.networkingLabel')
  //     }
  //   ],
  //   [url, t]
  // )

  return <UnityHubRoomsNavLayout items={items} />
}

export const CommunityRoomsNav = memo(CommunityRoomsNavView)
